import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class SetTransactionDepartment {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, department_id:string, listFilters?): Promise<any> {
    let args = {
      transaction_ids: transaction_ids,
      department_id: department_id,
      bank_account_id: uuid
    }
    try {
      await this.dispatcher.dispatch('set.transactions.department', args)
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(uuid, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
    } catch (error) {
      console.error('Error update transactions department', error)
    }
  }
}
